import qs from 'qs';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useCurrentUserId, useSessionUuid } from '#src/app/shared/hooks/session';
import { useShortUrls as useShortUrlsBase } from '#src/app/shared/hooks/shortUrls';

type GetShareUrlParams = { sessionUuid: string; currentUserId: string | undefined; slug: string };
function getShareUrl({ sessionUuid, currentUserId, slug }: GetShareUrlParams, utilityContext: UtilityContext): string {
	const { resolveUrl } = utilityContext;
	const recruiterTrackParams = !currentUserId ? {} : { recruiter: currentUserId };
	const recruitedByTrackParams = { recruited_by_id: sessionUuid };
	const trackParams = qs.stringify({
		...recruiterTrackParams,
		...recruitedByTrackParams,
		utm_source: 'share_petition',
		utm_campaign: 'petition_dashboard',
		utm_medium: 'copylink',
	});
	return resolveUrl(`/p/${slug}?${trackParams}`);
}

export function useShortUrls({ slug }: { slug: string }): Record<'copy', string> {
	const sessionUuid = useSessionUuid();
	const currentUserId = useCurrentUserId();
	const utilityContext = useUtilityContext();

	const shareUrlArgs = { sessionUuid, currentUserId, slug };
	return useShortUrlsBase({
		copy: getShareUrl({ ...shareUrlArgs }, utilityContext),
	});
}
